import Vue from 'vue'
import Router from 'vue-router'
import JwtDecode from 'jwt-decode'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import DashBoard from '@/components/DashBoard'
import Users from '@/components/Users'
import Board from '@/components/Board'
import Tasks from '@/components/Tasks'
import Inbox from '@/components/Inbox'
import Message from '@/components/Message'
import NewMessage from '@/components/NewMessage'
import ExternalMessage from '@/components/ExternalMessage'
import MyInbox from '@/components/MyInbox'
// admin imports
import Admin from '@/components/admin/Admin'
import AdminMailboxesIndex from '@/components/admin/mailboxes/Index'
import AdminMailbox from '@/components/admin/mailboxes/Show'
import AdminTeamsIndex from '@/components/admin/teams/Index'
import AdminTeam from '@/components/admin/teams/Show'
import AdminJotformsIndex from '@/components/admin/jotforms/Index'
import AdminJotform from '@/components/admin/jotforms/Show'
import AdminUsersIndex from '@/components/admin/users/Index'
import TaskTemplateCollections from '@/components/admin/TaskTemplateCollections'
import AdminClients from '@/components/admin/Clients'
import NotificationSettings from '@/components/NotificationSettings'
import AdminTags from '@/components/admin/Tags'
import Ticket from '@/components/Ticket'
import Search from '@/components/Search'
import AdminClient from '@/components/admin/AdminClient'
import Preferences from '@/components/UserPreferences'
import AdminReportsIndex from '@/components/admin/reports/Index'
import Customers from '@/components/customer/Index'
import Customer from '@/components/customer/Show'
import AdminFieldsIndex from '@/components/admin/fields/Index'
import AdminNewField from '@/components/admin/fields/Form'
import SavedReplies from '@/components/admin/SavedReplies'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/notification_settings',
      name: 'NotificationSettings',
      component: NotificationSettings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/preferences',
      name: 'Preferences',
      component: Preferences,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'fields',
          name: 'Fields',
          component: AdminFieldsIndex,
          children: [
            {
              path: 'new',
              name: 'NewField',
              component: AdminNewField
            },
            {
              path: ':id/edit',
              name: 'EditField',
              component: AdminNewField
            }
          ]
        },
        {
          path: 'reports',
          name: 'Reports',
          component: AdminReportsIndex
        },
        {
          path: 'clients',
          name: 'Clients',
          component: AdminClients,
          children: [
            {
              path: ':id',
              name: 'Client',
              component: AdminClient
            }
          ]
        },
        {
          path: 'tags',
          name: 'Tags',
          component: AdminTags
        },
        {
          path: 'task_templates_collections',
          name: 'TaskTemplateCollections',
          component: TaskTemplateCollections
        },
        {
          path: 'saved_replies',
          name: 'SavedReplies',
          component: SavedReplies
        },
        {
          path: 'mailboxes',
          name: 'Mailboxes',
          component: AdminMailboxesIndex,
          children: [
            {
              path: ':id',
              name: 'Mailbox',
              component: AdminMailbox
            },
            {
              path: 'new',
              name: 'MailboxNew',
              component: AdminMailbox
            }
          ]
        },
        {
          path: 'teams',
          name: 'Teams',
          component: AdminTeamsIndex,
          children: [
            {
              path: ':id',
              name: 'Team',
              component: AdminTeam
            },
            {
              path: 'new',
              name: 'TeamNew',
              component: AdminTeam
            }
          ]
        },
        {
          path: 'jotforms',
          name: 'Jotforms',
          component: AdminJotformsIndex,
          children: [
            {
              path: ':id',
              name: 'Jotform',
              component: AdminJotform
            },
            {
              path: 'new',
              name: 'JotformNew',
              component: AdminJotform
            }
          ]
        },
        {
          path: 'users',
          name: 'Users',
          component: AdminUsersIndex
        }
      ]
    },
    {
      path: '/boards',
      name: 'DashBoard',
      component: DashBoard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/boards/:id',
      name: 'Board',
      component: Board,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tasks',
      name: 'Tasks',
      component: Tasks,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/inboxes/:id',
      name: 'Inbox',
      component: Inbox,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ':subfolder_id',
          name: 'InboxSubfolder',
          component: Inbox
        }
      ]
    },
    {
      path: '/tickets/:id',
      name: 'Ticket',
      component: Ticket,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/messages/new',
      name: 'NewMessage',
      component: NewMessage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/messages/:id',
      name: 'Message',
      component: Message,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/messages/:id/token/:token',
      name: 'ExternalMessage',
      component: ExternalMessage
    },
    {
      path: '/my-inbox',
      name: 'MyInbox',
      component: MyInbox,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/customers',
      name: 'Customers',
      component: Customers,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ':id',
          name: 'Customer',
          component: Customer,
          props: true
        }
      ]
    }
  ],
  mode: 'history'
})

const loginSuccessful = function (response) {
  var token = response.data.jwt
  if (!token) {
    this.loginFailed()
    return
  }
  localStorage.token = token
  this.$store.dispatch('loadUser')
  this.$store.dispatch('loadUsers')
}

const loginFailed = function (e) {
  this.error = 'Login failed'
  delete localStorage.token
  this.$store.commit('logout')
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.token) {
      next({ name: 'Login' })
    } else {
      let today = new Date()
      today.setHours(today.getHours() - 1)
      let expireAt = new Date(JwtDecode(localStorage.token).exp * 1000)
      if (expireAt <= today) {
        this.$http.put('/refresh_token')
          .then(response => {
            loginSuccessful(response)
            next()
          })
          .catch((e) => {
            loginFailed(e)
            next({ name: 'Login' })
          })
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js